import { getRedirectURL, resolveUrlForTenant } from './page-availability'

/**
 * Resolves a deep-linked URL for a target country/locale.
 * Looks up the equivalent page in the target locale via the page availability service,
 * then constructs the final URL using the target country's domain.
 * Falls back to the static country URL if no equivalent page exists.
 * For National Pen, strips the origin and returns a relative URL.
 */
export async function resolveDeepLinkUrl(targetUrl: string, targetLocale: string, currentLocale: string, tenant?: string): Promise<string> {
  try {
    const pathname = globalThis.location?.pathname
    if (!pathname || pathname === '/') return resolveUrlForTenant(targetUrl, tenant)

    const redirectPath = await getRedirectURL({
      currentUrl: pathname,
      requestLocale: targetLocale,
      locale: currentLocale,
      tenant,
    })

    if (redirectPath && redirectPath !== '/') {
      const origin = new URL(targetUrl).origin
      return resolveUrlForTenant(`${origin}${redirectPath}`, tenant)
    }
  } catch {
    // Fall back to static URL on any error
  }
  return resolveUrlForTenant(targetUrl, tenant)
}
